import React, { useState, useEffect } from "react"
import { Footer } from '@chr/navisphereonline-shared-components';
import { loadAppConfig } from '@chr/online-shared-microsite-core';
import logoModule from '@chr/autoStyle/dist/img/CHR/CHR_LogoTM_Horz_2C_RGB.png';

export interface EmailConfirmationSuccessProps{
  email: string;
}

export const EmailConfirmationSuccess = (props: EmailConfirmationSuccessProps) => {
  const [ onlineOneUrl, setOnlineOneUrl ] = useState('');

  useEffect(() => {
    async function getUrl() {
      const { online1Uri } = await loadAppConfig() as AppConfig;
      setOnlineOneUrl(online1Uri);
    }

    getUrl()
  }, [])

  return (
    <div id="email-confirmed">
    <div className="container main margin-top-50">
      <div>
        <img
          className="chr-logo"
          src={logoModule}
          style={{maxWidth: '200px'}}
          alt="CHR-logo" />
      </div>
      <div className="margin-top-20">
        <h1 style={{color: '#333'}} >Email Confirmed!</h1>
      </div>

      <p>
        Thank you for confirming your email for
        <strong data-testid="profile-email"> {props.email}</strong>
      </p>

      <div className="margin-top-20">
        <a
          href={onlineOneUrl}
          className="btn btn-primary"
          data-testid="goto-btn"
        >
          Go to Customer Platform
        </a>
      </div>
    </div>
    <Footer />
  </div>
  );
}

